import * as Sentry from '@sentry/react';
import { Route, Routes as ReactRouterRoutes, Navigate } from 'react-router';
import * as URLS from '../constants/URLS.const';
import { DashboardRoutes } from './DashboardRoutes';
import { AuthenticationRoutes } from './AuthenticationRoutes';
import { useSelector } from 'react-redux';
import { RootState } from '@src/store/store';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(ReactRouterRoutes);

export function Routes() {
    const isAuthenticated = useSelector(
        (state: RootState) => state.user.user?.accessToken
    );
    return (
        <SentryRoutes>
            {!isAuthenticated ? (
                <>
                    <Route
                        path={`${URLS.ROOT}*`}
                        element={<AuthenticationRoutes />}
                    />
                </>
            ) : (
                <>
                    <Route
                        path={`${URLS.DASHBOARD_URL}/*`}
                        element={<DashboardRoutes />}
                    />
                    <Route
                        path="*"
                        element={<Navigate to={URLS.DASHBOARD_URL} replace />}
                    />
                </>
            )}
        </SentryRoutes>
    );
}
